import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  data() {
    return {
      device: {}
    };
  },

  methods: {
    checkWarhouseDeviceCode() {
      return WarehouseDevicesService.checkDeviceCode({
        device_code: this.device.device_code,
        warehouse_device_id: this.device.warehouse_device_id || this.device.id
      })
        .then(({ data }) => {
          return data.exists;
        })
        .catch(this.handleErrors);
    },

    showConfirm() {
      return this.$refs.confirm
        .open(null, this.$t('MESSAGE.DEVICE_EXISTS'), {
          messageClass: 'text-center text-md-h6 text-lg-h5 text-xl-h4',
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.CREATE')
        })
        .then(confirm => {
          return confirm;
        });
    }
  }
};
